import { Label } from "@/components/ui/label";

const Q = [
  ["gender", "Gender", [["woman", "Woman"], ["man", "Man"], ["non_binary", "Non-binary"], ["self_describe", "I describe myself another way"], ["prefer_not_to_say", "Prefer not to say"]]],
  ["age_band", "Age", [["under_25", "Under 25"], ["25_34", "25–34"], ["35_44", "35–44"], ["45_54", "45–54"], ["55_plus", "55 or over"], ["prefer_not_to_say", "Prefer not to say"]]],
  ["disability", "Do you consider yourself to have a disability?", [["yes", "Yes"], ["no", "No"], ["prefer_not_to_say", "Prefer not to say"]]],
];

export function DemographicsFields({ value, onChange }) {
  return (
    <fieldset className="space-y-3 rounded-[6px] border border-line p-4" data-testid="apply-demographics">
      <legend className="px-1 text-sm font-medium text-ink">Equal-opportunity questions (optional)</legend>
      <p className="text-xs leading-relaxed text-ink-secondary">These answers are voluntary and stored separately from your application. They are never shown to reviewers or used in scoring, and are only reported as anonymous totals to check our process is fair.</p>
      <div className="grid gap-3 sm:grid-cols-3">
        {Q.map(([k, label, opts]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={`demo-${k}`} className="text-xs">{label}</Label>
            <select id={`demo-${k}`} value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} className="h-9 w-full rounded-lg border border-line bg-white px-2 text-sm" data-testid={`apply-demo-${k}`}>
              <option value="">Skip this question</option>{opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
